import * as React from 'react';
import { translate } from 'components/translate-hoc';

// types
import { IEndOperationContentProps } from './end-operation-content.types';

// components
import PageSupportBlockContainer from 'modules/page-support-block';
import { TEXT_KEYS } from 'modules/end-operation/end-operation.constants';
import MarkupSwitcher from 'modules/markup-switcher';
import { StandaloneContent, EmbeddedContent } from './content';

import './end-operation-content.styles.less';

const EndOperationContent: React.FC<IEndOperationContentProps> = ({
    dangerouslyTranslateWithHTML: translateKey,
    shouldInheritStyles
}) => {
    const title = translateKey(TEXT_KEYS.TITLE);
    const message = translateKey(TEXT_KEYS.MESSAGE);
    const className = shouldInheritStyles ? 'betaError' : '';

    return (
        <div className={`${className} sitegen-end-of-operation`}>
            <MarkupSwitcher
                defaultBlock={<StandaloneContent title={title} message={message} />}
                inheritBlock={<EmbeddedContent title={title} message={message} />}
            />
            <PageSupportBlockContainer/>
        </div>
    );
};

export default translate()(EndOperationContent);
export {
    EndOperationContent
};
